module.exports = __webpack_public_path__ + "static/media/3.3ab07f1a.png";